import React from 'react';  
import './index.css';
import {  TextareaItem } from 'antd-mobile';
import { createForm } from 'rc-form';
 
class InfoBottom extends React.Component{
  constructor(props){
    super(props);
    this.state={
      value:''
    }
  }
  changeValueData(value){
    this.setState({
      value
    })
   
 }
 sendData(){
    this.props.sendData(this.state.value)
    this.setState({
        value:''
    })
 }
  render(){
    const { getFieldProps } = this.props.form;
    return (
      <div className="inter-bottom">
        <div className="inter-input">
          <TextareaItem
            rows={1}
            placeholder="我来说两句"
            clear
            count={200}
            value={this.state.value}
            onChange={(value)=>{this.changeValueData(value)}}
          />
        </div>
        <div className="inter-btn" onClick={()=>{this.sendData()}}>
          <span>发送</span>
        </div>
      </div>
      )
  }
}
const TextareaBottom = createForm()(InfoBottom);
export default TextareaBottom;